module.exports = __webpack_public_path__ + "static/media/allie06.e2b5f4e4.jpg";